module.exports = __webpack_public_path__ + "img/manche-air.64614328.jpg";